import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import swal from "sweetalert";
import SampEmp from "./SampEmp";
import { getDropDownVal } from "../dropdownUtils.js";
import CustomLoader from "../static/CustomLoader.js";
import {
  MasterPage,
  MasterToolbar,
  MasterButton,
  MasterSearch,
  MasterGrid,
  MasterDialog,
  MasterConfirmDialog,
} from "../static/Masterpage";

const SampEmpListing = () => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };

  const [loading, setLoading] = useState(false);
  const [employeeData, setEmployeeData] = useState([{}]);
  const [genderOptions, setGenderOptions] = useState([]);
  const [serach, setSerach] = useState("");
  const [density, setDensity] = useState("standard");
  const [showConfirm, setShowConfirm] = useState(false);
  const [addShow, setAddShow] = useState(false);
  const [editShow, setEditShow] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [filterData, setFilterData] = useState([{}]);

  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "empid",
      headerName: "Employee Id",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "gender",
      headerName: "Gender",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const typeOption = genderOptions.find(
          (option) => option.value === params.value,
        );
        return typeOption ? typeOption.label : params.value;
      },
    },
  ];

  useEffect(() => {
    fetchData();
  }, [refresh]);

  useEffect(() => {
    const fetchGenderOptions = () => {
      try {
        const response = getDropDownVal("GN");
        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));
        setGenderOptions(actOption);
      } catch (error) {
        console.log("error");
      }
    };

    fetchGenderOptions();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      axios
        .get(apiUrl + "employee", {
          headers,
        })
        .then((response) => {
          setEmployeeData(response.data);
          setFilterData(response.data);
          setRefresh(false);
          setSelectedData("");
          setLoading(false);
        })
        .catch((error) => {
          console.log("error " + error);
          setEmployeeData([{}]);
          setLoading(false);
        });
    } catch (error) {
      setEmployeeData([{}]);
      setLoading(false);
    }
  };

  const handlesearch = (event) => {
    const getSearch = event.target.value.toLowerCase();

    if (getSearch.length > 0) {
      const searchdata = filterData.filter((item) =>
        Object.keys(item).some((key) =>
          String(item[key]).toLowerCase().includes(getSearch),
        ),
      );
      setEmployeeData(searchdata);
    } else {
      setEmployeeData(filterData);
    }

    setSerach(getSearch);
  };

  const addHandleShow = () => {
    setAddShow(true);
  };

  const addHandleClose = () => {
    setShowConfirm(true);
  };

  const editHandleShow = () => {
    if (selectedData.length > 1 || selectedData.length === 0) {
      toast.warning("Please Select only one value");
      return;
    }
    setEditShow(true);
  };

  const editHandleClose = () => {
    setShowConfirm(true);
  };

  const handleConfirmClose = () => {
    setShowConfirm(false);
    setAddShow(false);
    setEditShow(false);
  };

  const handleCancelClose = () => {
    setShowConfirm(false);
  };

  const RemoveFunction = async () => {
    if (selectedData) {
      const selectedDataStr = String(selectedData);

      swal({
        title: "Do you want to remove?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (confirmDelete) => {
        if (confirmDelete) {
          try {
            setLoading(true);

            await axios.delete(`${apiUrl}employee/${selectedDataStr}`, {
              headers,
            });

            toast.success("Record removed successfully.");
            fetchData();
            setLoading(false);
          } catch (error) {
            setLoading(false);
            console.error("Error deleting record:", error);
            toast.error("Error occurred while removing the record.");
          }
        }
      });
    } else {
      toast.warning("Please Select at least one value");
      setLoading(false);
    }
  };

  return (
    <>
      <MasterPage>
        <MasterToolbar
          actions={
            <>
              <MasterButton
                variant="add"
                tooltip="Create new Employee"
                onClick={addHandleShow}
                disabled={loading}
              >
                Add
              </MasterButton>

              <MasterButton
                variant="update"
                tooltip="Edit Selected Employee"
                onClick={editHandleShow}
                disabled={loading}
              >
                Update
              </MasterButton>

              <MasterButton
                variant="danger"
                tooltip="Delete Selected Employee"
                onClick={RemoveFunction}
                disabled={loading}
              >
                Delete
              </MasterButton>
            </>
          }
          search={
            <MasterSearch
              tooltip="Search by All"
              value={serach}
              onChange={handlesearch}
              inputRef={(input) => input && input.focus()}
            />
          }
        />

        <MasterGrid
          density={density}
          onDensityChange={(newDensityString) => setDensity(newDensityString)}
          rows={
            employeeData !== null &&
            employeeData.length > 0 &&
            Object.keys(employeeData[0]).length !== 0 &&
            employeeData
          }
          columns={columns}
          onRowClick={(params) => {
            setSelectedData(params.row.code);
          }}
        />
      </MasterPage>

      {loading && <CustomLoader />}

      <MasterDialog
        open={addShow}
        onHide={addHandleClose}
        title="Add Employee Details"
        maxWidth="md"
      >
        <SampEmp
          selectedId=""
          mode="A"
          onHide={addHandleClose}
          setRefresh={setRefresh}
        />
      </MasterDialog>

      <MasterDialog
        open={editShow}
        onHide={editHandleClose}
        title="Edit Employee Details"
        maxWidth="md"
      >
        <SampEmp
          selectedId={selectedData}
          mode="U"
          onHide={editHandleClose}
          setRefresh={setRefresh}
        />
      </MasterDialog>

      <MasterConfirmDialog
        show={showConfirm}
        title="Close Confirmation"
        message="Are you sure you want to close this modal?"
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
      />
    </>
  );
};

export default SampEmpListing;
